module.exports = __webpack_public_path__ + "static/media/fake-user-image.fe589296.png";